import $ from 'jquery';
import BackgroundImage from '../core/BackgroundImage';
import Placeholder from '../components/Placeholder';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.bg();
    this.placeholder();
    this.searchForm();
    this.ready();
  }

  bg() {
    this.element.querySelectorAll('.node-home-hero').forEach((elem) => {
      if (!elem.Bg) {
        elem.Bg = new BackgroundImage(elem, {
          sourceSelector: 'figure img',
          destSelector: '.node-image',
        });
      }
    });
  }

  placeholder() {
    this.element.querySelectorAll('.type-textfield').forEach((element) => {
      if (!element.placeholder) {
        element.placeholder = new Placeholder(element);
      }
    });
  }

  searchForm() {
    const textField = this.$element.find('#heroForm');
    $(textField).on('input', () => {
      window.console.log(textField[0].value);
      document.getElementById('edit-keywords').value = textField[0].value;
    });

    const submitButton = this.$element.find('#heroSubmit');
    $(submitButton).on('click', (event) => {
      event.preventDefault();
      document.querySelector('.dd-search-submit-button').click();
    });
  }

  ready() {
    this.element.classList.add('ready');
  }
}
